import{jsx as t}from"react/jsx-runtime";import{forwardRef as r}from"react";import{TextLink as e}from"@vds-core/buttons";const o=r((function(r,o){return t(e,Object.assign({},r,{textLinkRef:o}))}));export{o as default};
